import React from 'react';

const Icon = () => {
    return (
        <svg
            fill='#00787A'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            width='14px'
            height='14.5px'
        >
            <path
                d='M 8 3 L 3 8 L 7 8 L 7 16 C 7 18.749516 9.2504839 21 12 21 L 21 21 L 21 19 L 12 19 C 10.331516 19 9 17.668484 9 16 L 9 8 L 13 8 L 8 3 z'
            />
        </svg>
    );
};

export default Icon;